<template>
    <div class="wrapper">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7203 0H2.68794C1.20973 0 0 1.35 0 3V10.6875H10.7203C13.6893 10.6875 16.0962 8.295 16.0962 5.34375C16.0962 2.3925 13.6893 0 10.7203 0Z" fill="#11F47D"/>
            <path d="M10.7203 16H2.68794C1.20973 16 0 14.65 0 13V5.3125H10.7203C13.6893 5.3125 16.0962 7.705 16.0962 10.6562C16.0962 13.6075 13.6893 16 10.7203 16Z" fill="#1D72F4"/>
            <path d="M15.386 8C14.4586 6.39406 12.7166 5.3125 10.7203 5.3125H0V10.6875H10.7203C12.7166 10.6875 14.4586 9.60594 15.386 8Z" fill="#00C78F"/>
        </svg>
        <strong class="title">{{ 'Briskly' }}</strong>
    </div>
</template>

<style lang="scss" scoped>
    .wrapper {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-bottom: 4px;
    }

    .title {
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        color: #515c72;
    }
</style>
